module.exports = __webpack_public_path__ + "assets/img/transparency-2.6038e01c.svg";